import { gql as untypedGql } from "@apollo/client";

/**
 * Codegen excludes these hand-written documents, so they carry no result
 * types. Apollo Client 3 typed an untyped document's data as `any`; Apollo
 * Client 4 types it as `unknown`, which broke every reader. This keeps the
 * Apollo Client 3 typing until the documents are retired (separate work).
 *
 * @type {(...args: Parameters<typeof untypedGql>) => import("@apollo/client").TypedDocumentNode<any, any>}
 */
const gql = untypedGql;

import * as fragments from "./fragments";

export const COUNTRIES = gql`
	query {
		countries {
			id
			name
			callingCode
			isoAlpha2
		}
	}
`;

export const CURRENCIES = gql`
	query {
		currencies {
			id
			name
			abbreviation
			symbol
			decimalSeparator
			thousandsSeparator
		}
	}
`;

export const FEATURES = gql`
	query Features {
		features {
			name
			isEnabled
		}
	}
`;

export const INVESTING_ENTITY = gql`
	query InvestingEntity {
		account {
			activeInvestingEntity {
				...investingEntityFields
			}
		}
	}
	${fragments.INVESTING_ENTITY}
`;

export const ME = gql`
	query Me {
		account {
			...accountFields
		}
	}
	${fragments.ACCOUNT}
`;

export const ACCOUNT_NOTIFICATION = gql`
	query AccountNotification($type: NotificationType!) {
		account {
			id
			notification(type: $type) {
				...accountNotificationFields
			}
		}
	}
	${fragments.ACCOUNT_NOTIFICATION}
`;

export const INVESTING_ENTITY_NOTIFICATION = gql`
	query InvestingEntityNotification($type: NotificationType!) {
		account {
			activeInvestingEntity {
				id
				notification(type: $type) {
					...investingEntityNotificationFields
				}
			}
		}
	}
	${fragments.INVESTING_ENTITY_NOTIFICATION}
`;

export const BENEFICIAL_OWNER_CONTACTS = gql`
	query BeneficialOwnerContacts {
		beneficialOwnerContacts {
			id
			firstName
			lastName
			relationships
			email
			mobilePhone {
				phoneNumber
				callingCode
			}
		}
	}
`;

export const SESSION = gql`
	query Session {
		session {
			...sessionFields
		}
	}
	${fragments.SESSION}
`;

export const INITIALIZE_APP = gql`
	query InitializationApp {
		account {
			...accountFields
		}
		session {
			...sessionFields
		}
	}
	${fragments.ACCOUNT}
	${fragments.SESSION}
`;
